import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getSiteAbortApproval,
  acceptSiteStatusApproval,
  rejectAbortApproval,
} from 'services/redux/approvals/mrfApprovals/action';
import PostponeInstallationApprovalList from './postponeInstallationApprovalsList';

import {
  getInstallationDateChangeListing,
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
  installationDateChangeListing:state.siteListingReducer.installationDateChangeListing
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInstallationDateChangeListing,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostponeInstallationApprovalList);
